import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const uploadDocumentForDona = (file, case_type) => {
  console.log("File: ", file);
  const loginData = secureLocalStorage.getItem("loginCredentials");
  const userId = loginData?.user?.id;

  if (!userId || !file) {
    return Promise.reject(new Error("User ID and file are required"));
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("user_id", userId);
  formData.append("case_type", case_type);

  // Log FormData keys and values for debugging
  formData.forEach((value, key) => {
    console.log(key, value);
  });

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_PYTHON_URL}/api/v1/documents/save`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => {
        console.error("Error uploading document:", err);
        reject(err);
      });
  });
};
//

const createCase = (caseData) => {
  const loginData = secureLocalStorage.getItem("loginCredentials");
  caseData["userId"] = loginData.user.id;
  caseData["upload_date"] = Date.now;
  console.log("caseData: ", caseData);
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_NODE_BASE_URL}/case/createCase`, caseData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

const getAllCases = async () => {
  try {
    console.log(" Fetching all cases...");
    const loginData = secureLocalStorage.getItem("loginCredentials");
    const response = await axios.get(
      `${process.env.REACT_APP_NODE_BASE_URL}/case/getAllCases`,
      {
        params: { userId: loginData?.user?.id },
      }
    );

    console.log(" Cases fetched:", response.data);
    return response.data;
  } catch (err) {
    console.error(" Error fetching cases:", err.message);
    throw err;
  }
};

// const getAllCases = () => {
//     const loginData = secureLocalStorage.getItem("loginCredentials");

//     return new Promise((resolve, reject) => {
//       axios
//         .get(`${process.env.REACT_APP_NODE_BASE_URL}/case/getAllCasesByUserId/${loginData.user.id}`)
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => reject(err));
//     });
//   };

const deleteCase = (caseId) => {
  const loginData = secureLocalStorage.getItem("loginCredentials");
  console.log(caseId)
  return new Promise((resolve, reject) => {
    axios
      .delete(
        `${process.env.REACT_APP_NODE_BASE_URL}/case/deleteCase/${caseId}`,
        { data: { userId: loginData?.user?.id } }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

const getAllCasesStatistics = () => {
  const loginData = secureLocalStorage.getItem("loginCredentials");

  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_NODE_BASE_URL}/case/statistics/${loginData.user.id}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

export {
  createCase,
  getAllCases,
  deleteCase,
  getAllCasesStatistics,
  uploadDocumentForDona,
};
